import HistoryVideo from "./HistoryVideo";
import { Button } from '@material-ui/core';
import React, {useState, useEffect} from "react";
import {ThreeDots} from "@agney/react-loading";

const History = ({socket, history, filter, deepSearch, cookies}) => {
    const [waitingForResponse, setWaitingForResponse] = useState(false);

    useEffect(() => {
        if (deepSearch && waitingForResponse) {
            setWaitingForResponse(false);
        }
    });

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!waitingForResponse) {
            setWaitingForResponse(true);
            socket.emit('searchHistory', filter);
        }
    }

    const onReturn = async (e) => {
        e.preventDefault();
        socket.emit('forceRefreshHistory')
    }

    return (
        <>
            <div>
                {history.length > 0 ? history.map((video) => (
                    <HistoryVideo key={video.queueUUID} video={video} socket={socket} cookies={cookies}/>
                )) : <p className='EmptyQueue'>{filter != '' ? 'No Videos Match Your Search' : 'No Previously Played Videos'}</p>}
                {!waitingForResponse && filter != '' && !deepSearch && <Button style={{backgroundColor: '#d20000', display: 'block', marginLeft: 'auto', marginRight: 'auto'}} variant="contained" color='secondary' disableElevation onClick={onSubmit}>Search More</Button>}
                {waitingForResponse && !deepSearch && <ThreeDots  height='16px' style={{display: 'block', paddingTop: '10px', marginLeft: 'auto', marginRight: 'auto'}}/>}
                {deepSearch && <Button style={{backgroundColor: '#d20000', display: 'block', marginLeft: 'auto', marginRight: 'auto'}} variant="contained" color='secondary' disableElevation onClick={onReturn}>Return</Button>}
            </div>
        </>

    )
}

export default History;